import styled from "styled-components";
import { Row } from "antd";

export const CitiesListWrapper = styled(Row)`
  margin-bottom: 40px;
  position: relative;
  background: #fbfbfb;
  padding-right: 100px;

  .ant-menu {
    background: inherit;

    &-horizontal {
      border-bottom: 0;
    }
  }
`;

export const CitiesListAction = styled.div`
  position: absolute;
  top: 50%;
  right: 25px;
  transform: translateY(-50%);
`;
